// ============================================================
// scheduleAlignedRefresh - heredado del audit v1 § 3.1.
//
// Auto-refresh alineado a :05 segundos despues de cada minuto-de-reloj.
// Usa setTimeout recursivo (no setInterval) para evitar drift acumulado.
//
// El primer tick en frio es entre 5 y 65 segundos dependiendo del segundo
// en el que se monto el componente. La sincronizacion al :05 le da al
// trader una sensacion "live": todos los datos cambian al mismo tiempo.
// ============================================================

export interface ScheduledTask {
  cancel(): void;
}

export function scheduleAlignedRefresh(
  callback: () => void | Promise<void>,
  alignSecond = 5,
): ScheduledTask {
  let timer: ReturnType<typeof setTimeout> | null = null;
  let cancelled = false;

  function scheduleNext(): void {
    if (cancelled) return;
    const now = new Date();
    const seconds = now.getSeconds();
    const ms = now.getMilliseconds();
    // Cuanto falta para el proximo :alignSecond. Si ya pasamos en este minuto,
    // apuntar al siguiente minuto.
    let delaySec = alignSecond - seconds;
    if (delaySec <= 0) delaySec += 60;
    const delayMs = delaySec * 1000 - ms;
    timer = setTimeout(async () => {
      if (cancelled) return;
      try {
        await callback();
      } finally {
        scheduleNext();
      }
    }, delayMs);
  }

  scheduleNext();

  return {
    cancel(): void {
      cancelled = true;
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    },
  };
}

// ============================================================
// debounce - util generica.
// ============================================================
// biome-ignore lint/suspicious/noExplicitAny: helper generico
export function debounce<F extends (...args: any[]) => void>(fn: F, delayMs: number): F {
  let timer: ReturnType<typeof setTimeout> | null = null;
  return ((...args: Parameters<F>) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delayMs);
  }) as F;
}
